import { Injectable, OnInit } from '@angular/core';
import { Filter } from '../models/filter.model';
import { Subject } from 'rxjs';
import { BrowserStorageService } from 'src/app/shared/browser-storage.service';

@Injectable()
export class FilterService {
    appliedFiltersChanged = new Subject<string[]>();

    svRangeFrom: number;
    svRangeTo: number;
    searchFilters: Filter[];
    resultFilters: Filter[];
    appliedFilters: string[] = [];

    constructor(private storage: BrowserStorageService) { 
        this.svRangeFrom = 0;
        this.svRangeTo = 16;
        this.searchFilters = [
            new Filter("Distributors", true, "D"),
            new Filter("Suppliers", true, "S"),
            new Filter("Business Services", true, "A"),
            new Filter("Multi-Line Reps", true, "R")
        ];
        this.resultFilters = [
            new Filter("PSA", false, "IsPsa"),
            new Filter("Woman Owned", false, "IsWomanOwned"),
            new Filter("Minority Owned", false, "IsMinorityOwned"),
            new Filter("Veteran Owned", false, "IsVeteranOwned")
        ];
        this.getSearchFiltersFromLocal();
        this.getResultFiltersFromLocal();
    }
    updateSalesVolumeRangeFrom(value: number){
        this.svRangeFrom = value;
    }
    updateSalesVolumeRangeTo(value: number){
        this.svRangeTo = value;
    }
    updateSearchFilter(filterExpression: string, checked: boolean){
        var filterToUpdate = this.searchFilters.find(x => x.Expression === filterExpression);
        filterToUpdate.Checked = checked;
        this.saveSearchFiltersToLocal();
    }
    updateResultFilter(filterExpression: string, checked: boolean){
        var filterToUpdate = this.resultFilters.find(x => x.Expression === filterExpression);
        filterToUpdate.Checked = checked;
        if (checked){
            this.appliedFilters.push(filterExpression);
        }
        else{
            const index = this.appliedFilters.indexOf(filterExpression, 0);
            if (index > -1) {
                this.appliedFilters.splice(index, 1);
            }
        }
        this.appliedFiltersChanged.next(this.appliedFilters);
        this.saveResultFiltersToLocal();
    }

    getSearchFilters(){
        return this.searchFilters;
    }
    getResultFilters(){
        return this.resultFilters;
    }
    getAppliedFilters(){
        return this.appliedFilters;
    }
    saveSearchFiltersToLocal(){
        this.storage.savePermanent('SearchFilters2', JSON.stringify(this.searchFilters));
    }
    saveResultFiltersToLocal(){
        this.storage.savePermanent('ResultFilters2', JSON.stringify(this.resultFilters));
    }
    getSearchFiltersFromLocal(){
        var filters = this.storage.getPermanentValue("SearchFilters2");
        if (filters.length > 0)
            this.searchFilters = JSON.parse(filters);
    }
    getResultFiltersFromLocal(){
        var filters = this.storage.getPermanentValue("ResultFilters2");
        if (filters.length == 0) return;
        var rFilters: Filter[] = JSON.parse(filters);
        if (rFilters.length > 0){
            this.resultFilters = rFilters;
            this.resultFilters.forEach(element => {
                if (element.Checked){
                    this.appliedFilters.push(element.Expression);
                }
            });
            this.appliedFiltersChanged.next(this.appliedFilters);
        }
    }
}